import axios from 'axios';

export default axios.create({
    baseURL: 'https://storagecleverbasic.blob.core.windows.net/p4lgroup-data/kubelikova/',

});